
import ProductCard from '~/components/product/ProductCard.vue';

export default {
  data() {
    return {};
  },
  components: {
    ProductCard,
  },
  props: {
    recentlyProducts: {
      type: Array,
      default: () => [],
    },

    relatedProducts: {
      type: Array,
      default: () => [],
    },

    sameProducts: {
      type: Array,
      default: () => [],
    },

    currentProductId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    recentlyProductsFiltered() {
      return this.recentlyProducts.filter((t) => t.id !== this.currentProductId) || [];
    },
  },
};
